import type { PrivacyStrings } from "../../types";

export const privacy: PrivacyStrings = {
  "title": "隐私政策",
  "lastUpdated": "最后更新：2026 年 11 月 3 日",
  "sections": [
    {
      "title": "概述",
      "paragraphs": [
        {
          "nodes": [
            "本政策涵盖 Cate 桌面应用、Cate Connect 和本网站。Cate 是本地优先的工作空间：文件和会话保存在运行工作空间 runtime 的电脑上，你可以通过配对设备访问它们。下方链接的移动端补充说明介绍适用于 iPhone 的 Cate Mobile 特有的额外处理。两份声明共用此处说明的数据控制者和权利信息。"
          ]
        },
        {
          "nodes": [
            {
              "link": "Cate Mobile 隐私补充说明",
              "href": "/mobile/privacy"
            }
          ]
        }
      ]
    },
    {
      "title": "数据控制者",
      "paragraphs": [
        {
          "pre": true,
          "nodes": [
            "0-AI UG (haftungsbeschränkt)\nNeckartalstraße 127\n70376 Stuttgart\n德国"
          ]
        },
        {
          "nodes": [
            "电子邮件：",
            {
              "mail": "contact@cero-ai.com"
            }
          ]
        }
      ]
    },
    {
      "title": "桌面端崩溃报告与使用分析",
      "paragraphs": [
        {
          "nodes": [
            "打包的桌面版本通过 Sentry 提供崩溃报告，并通过我们的自建服务进行使用分析。自桌面版本 1.3.1 起，这些功能始终开启且无法关闭。使用事件包括应用启动、安装、更新和功能使用，以及应用版本、平台和语言等技术信息。随机安装标识符用于关联同一安装的事件；它不是你的姓名或邮箱地址。"
          ]
        },
        {
          "nodes": [
            "使用事件不包含工作空间内容、文件路径或 AI 消息。崩溃报告包含错误、堆栈和技术信息；用户主目录路径会被掩盖，导航网址仅保留来源部分。我们基于保障稳定性和改进产品的合法利益处理诊断数据（GDPR 第 6(1)(f) 条）。这些桌面报告说明不适用于 iOS 应用；请参阅移动端补充说明。"
          ]
        }
      ]
    },
    {
      "title": "AI 提供商与你打开的网站",
      "paragraphs": [
        {
          "nodes": [
            "代理请求从工作空间 runtime 发往你配置的提供商，使用你的账户或 API 密钥，并受该提供商的条款约束。请求可能包含代理选择的代码、文件片段、消息、附件和工具输出。浏览器面板会连接你打开的网站。这些服务适用其自身的隐私政策，并可能在欧洲经济区以外处理数据。"
          ]
        }
      ]
    },
    {
      "title": "Cate Connect",
      "paragraphs": [
        {
          "nodes": [
            "Cate Connect 协助配对设备建立连接，并在需要时中继流量。工作空间流量在配对设备之间加密，服务无法读取其明文。建立连接需要处理 runtime 标识、公钥、连接信令以及 IP 地址等网络元数据。我们的托管和网络提供商处理运行服务所需的流量。"
          ]
        },
        {
          "nodes": [
            "活动连接的注册信息保存在内存中，并在 runtime 断开后删除。运行日志按排查错误和保护服务所需的用途使用。我们根据 GDPR 第 6(1)(b) 条处理提供所请求服务所需的连接数据，并根据第 6(1)(f) 条处理保障安全和可靠性所需的运行数据。如需撤销配对设备的访问权限，请在运行 runtime 的电脑上通过 Cate 移除该设备。移动端补充说明介绍 iOS 推送和设备存储。"
          ]
        }
      ]
    },
    {
      "title": "自动更新",
      "paragraphs": [
        {
          "nodes": [
            "打包的桌面版本会向 GitHub 检查更新。GitHub 根据其自身隐私声明接收响应所需的网络信息，包括你的 IP 地址。Apple 通过 App Store 分发和更新 iOS 应用。"
          ]
        }
      ]
    },
    {
      "title": "我们在网站上处理的数据",
      "paragraphs": [
        {
          "nodes": [
            "本网站使用 analytics.cero-ai.com 上的自建分析服务记录页面浏览和来源页面。跟踪脚本不设置 cookie，也不创建持久的访客标识符。网络服务会接收你的 IP 地址以提供和保护网站。我们基于运营和了解网站的合法利益处理这些信息（GDPR 第 6(1)(f) 条）。你选择的语言和主题保存在浏览器本地。"
          ]
        },
        {
          "nodes": [
            "如果你订阅资讯，我们会基于你的同意（GDPR 第 6(1)(a) 条）使用邮箱地址发送产品更新，由 Resend 提供邮件服务。你可随时退订，之后邮箱地址会从邮件列表中删除。网站还会加载 GitHub 版本信息、Product Hunt 徽章和 Google 字体；这些服务在加载内容时会接收网络信息。"
          ]
        }
      ]
    },
    {
      "title": "你的权利",
      "paragraphs": [
        {
          "nodes": [
            "根据 GDPR，你有权访问自己的个人数据，要求更正或删除，限制或反对对其处理，并要求数据可携带。如果某项处理是基于你的同意进行的，你可以随时撤回同意。要行使上述任何一项权利，请联系我们：",
            {
              "mail": "contact@cero-ai.com"
            },
            "。"
          ]
        },
        {
          "nodes": [
            "你也有权向监管机构投诉，就我们而言，对应的是巴登-符腾堡州数据保护与信息自由专员。"
          ]
        }
      ]
    },
    {
      "title": "本政策的变更",
      "paragraphs": [
        {
          "nodes": [
            "随着应用和网站的演进，我们可能会更新本政策。如有重大变更，会同步更新上方的「最后更新」日期。若有任何疑问，欢迎联系我们：",
            {
              "mail": "contact@cero-ai.com"
            },
            "。"
          ]
        }
      ]
    }
  ]
};
